import { render, staticRenderFns } from "./SimilarModelsScroller.vue?vue&type=template&id=f07168c0&scoped=true&"
import script from "./SimilarModelsScroller.vue?vue&type=script&lang=js&"
export * from "./SimilarModelsScroller.vue?vue&type=script&lang=js&"
import style0 from "./SimilarModelsScroller.vue?vue&type=style&index=0&id=f07168c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f07168c0",
  null
  
)

export default component.exports